import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Route, Switch } from "react-router-dom";

import { CookieModal } from "../components/cookie-modal";
import { Footer } from "../components/footer";
import { TermsPrompt } from "../components/terms-prompt";
import { ForgotOrg } from "../routes/forgot_org";
import { LoginPage } from "../routes/login_page";
import { OrgInputPage } from "../routes/org_input";
import { OrgLogin, OrgLoginPassword } from "../routes/org_login";
import { OrgPicker } from "../routes/org_picker";
import { PasswordReset } from "../routes/password_reset";
import { RequestPasswordReset } from "../routes/request_password_reset";
import { LoginStore } from "../store/login";
import { getQueryParam } from "src/utils";

const LoginLayout = () => {
  const dispatch = useDispatch();
  useEffect(setDataFromServer, [dispatch]);

  return (
    <div>
      <Switch>
        {/* TODO: change urls below */}
        <Route exact path="/sso" component={OrgInputPage} />
        {window.waffle.flag_is_active("redirect_zu") && window.context.uaeRedirectUrl && (
          <Route
            exact
            path="/org/zu"
            component={() => {
              window.location.href = `${window.context.uaeRedirectUrl}/org/zu`;
              return null;
            }}
          />
        )}
        <Route exact path="/org/:orgIdentifier" component={OrgLogin} />
        <Route
          exact
          path="/org/:orgIdentifier/request-password-reset"
          component={RequestPasswordReset}
        />
        <Route exact path="/org/:orgIdentifier/reset-password" component={PasswordReset} />
        <Route exact path="/org/:orgIdentifier/password" component={OrgLoginPassword} />
        <Route exact path="/forgot-org" component={ForgotOrg} />
        <Route exact path="/select-org" component={OrgPicker} />
        <Route exact path="/" component={LoginPage} />
        <Route exact path="/password" component={OrgLoginPassword} />
        <Route exact path="/request-password-reset" component={RequestPasswordReset} />
        <Route exact path="/reset-password" component={PasswordReset} />
        <Route exact path="/accept-terms" component={TermsPrompt} />
      </Switch>
      <Footer />
      <CookieModal />
    </div>
  );

  function setDataFromServer() {
    dispatch(LoginStore.actions.update({ contextualMessage: null }));
    const { errorMessage } = window.context || getQueryParam("error") || {};
    if (errorMessage) {
      dispatch(LoginStore.actions.setError(errorMessage));
      window.context.errorMessage = "";
    }
  }
};

export { LoginLayout };
